module.exports = __webpack_public_path__ + "static/img/atlasGif.6f343d89.gif";